/** Entrada pelo Auth Reader, atraves do backend do viewer (spec 0004: app api key `ak-`). */

import { apiGet, apiPost, type Envelope } from '../api/client'
import type { LoginResult, Me } from '../api/types'

export function login(email: string, password: string): Promise<LoginResult> {
  return apiPost<LoginResult>('/auth/login', { email, password })
}

export async function fetchMe(): Promise<Me> {
  const resposta = await apiGet<Envelope<Me>>('/auth/me')
  const primeiro = resposta.rows[0]
  if (primeiro === undefined) throw new Error('sessao sem usuario')
  return primeiro
}
